// Modules
import { MODAL_FORGOT_PASSWORD_DATA } from 'constants/singin'
import { useAnalytics } from 'hooks'
import React, { useEffect } from 'react'
import { CustonModalOrBootomSheet } from 'redesign/components/molecules/CustomModalOrBottomSheet'
import { CustomModalOrBottomSheetCell } from 'redesign/components/molecules/CustomModalOrBottomSheetCell'
import { useCPFLoginForm } from 'redesign/hooks/useCPFLoginForm'

type ModalCipProps = {
    setShowModal: (value: boolean) => void
    showModal: boolean
}

export const ModalForgotPassword = ({ setShowModal, showModal }: ModalCipProps) => {
    const { values } = useCPFLoginForm()
    const { trackEvent } = useAnalytics()

    useEffect(() => {
        showModal &&
            trackEvent({
                event: 'funnel_step',
                funnel: {
                    name: 'login_faseado',
                    current_step: 'Modal - Esqueci a senha',
                },
            })
    }, [showModal, trackEvent])

    return (
        <CustonModalOrBootomSheet
            setShowModal={setShowModal}
            showCloseButtonModal={false}
            showModal={showModal}
            title={MODAL_FORGOT_PASSWORD_DATA.title}
        >
            <p>{MODAL_FORGOT_PASSWORD_DATA.subtitle}</p>
            <CustomModalOrBottomSheetCell itens={MODAL_FORGOT_PASSWORD_DATA.itens} user={values.cpf} />
        </CustonModalOrBootomSheet>
    )
}
